module.exports = __webpack_public_path__ + "static/img/2.6f78f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/2.png
// module id = C+oY
// module chunks = 1